export default "__VITE_ASSET__CKBhz$IW__"